import axios from 'axios'
import { stringify, parse } from 'query-string'
import store from '@state/store'
import i18n from '@/i18n'
import router from '@/router/index'

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

/**
  @param {} endpoint api url
  @param {} method http request method POST, PUT, GET, DELETE
  @param {} payload request body
  @param {} params request params
 * @returns Promise
 */

export const request = async ({
  endpoint,
  method = 'post',
  payload,
  params,
  isDisplaySnackbar = false,
}) => {
  const query = params
    ? `?${stringify({
        ...params,
      })}`
    : ''
  try {
    const Key = store.state.auth.credential.Key
    const companyId = store.state.auth.companyId
    const resHashKey = await axios({
      method,
      url: '/api/hashkey',
      headers: {
        'content-type': 'application/json; utf-8',
      },
      data: {
        ...payload,
        Key,
        company_id: companyId,
      },
    })
    if (resHashKey.data.ErrorCode === '00000') {
      const response = await axios({
        method,
        url: `${endpoint}${query}`,
        headers: {
          'content-type': 'application/json; utf-8',
        },
        data: {
          ...payload,
          Key,
          company_id: companyId,
        },
      })
      return handleResponse(response, isDisplaySnackbar)
    }
  } catch (error) {
    store.dispatch('auth/resetCurrentSessionId')
    router.push({
      name: 'login',
      params: { companyId: store.state.auth.companyId },
    })
    return Promise((resolve, reject) => reject(error))
  }
}

export const requestNoLogin = async ({
  endpoint,
  method = 'post',
  payload,
  params,
  isDisplaySnackbar = false,
}) => {
  const query = params
    ? `?${stringify({
        ...params,
      })}`
    : ''
  try {
    const response = await axios({
      method,
      url: `${endpoint}${query}`,
      headers: {
        'content-type': 'application/json; utf-8',
      },
      data: {
        ...payload,
      },
    })
    return handleResponse(response, isDisplaySnackbar)
  } catch (error) {
    return Promise((resolve, reject) => reject(error))
  }
}

const handleResponse = (response, isDisplaySnackbar) =>
  new Promise((resolve, reject) => {
    const { data } = response
    const query = parse(window.location.search)
    switch (data.ErrorCode) {
      case '00000':
        if (isDisplaySnackbar) {
          store.dispatch('snackbar/setSnackbar', {
            color: '#b7d6a2',
            text: i18n.t('snackbarSuccess'),
          })
        }

        return resolve(data)
      case '90002':
        router.push({
          name: 'resendQr',
          query,
        })
        break
      default:
        store.dispatch('snackbar/setSnackbar', {
          color: 'red',
          text: i18n.t('snackbarError'),
        })
        return reject(data.Msg)
    }
  })
